import { Identity, IsString, RecordMap } from "@pdfking/tfunc"
import get_filedata from "./get_filedata"

const shorten = (path: string): string => {
  const { basename, ext } = get_filedata(path)
  return ext ? `${basename}.${ext}` : basename
}

function get_short_name(path: string): string
function get_short_name<T>(paths: Record<string, T>): Record<string, T>
function get_short_name<T>(
  input: string | Record<string, T>
): string | Record<string, T> {
  if (IsString(input)) return shorten(input)
  return RecordMap(input, (_v, k) => shorten(k), Identity)
}

export default get_short_name
